import { render, staticRenderFns } from "./countyProfile.vue?vue&type=template&id=0a33077c&scoped=true"
import script from "./countyProfile.vue?vue&type=script&lang=js"
export * from "./countyProfile.vue?vue&type=script&lang=js"
import style0 from "./countyProfile.vue?vue&type=style&index=0&id=0a33077c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33077c",
  null
  
)

export default component.exports